<template>
    <div id="app">
        <div
            class="main-content"
            :class="
                $route.meta.showSideBar == false ? 'content-full-width' : ''
            "
        >
            <base-sidebar
                v-if="$route.meta.showSideBar"
                :class="sidebarResponsive == true ? 'show-sidebar' : ''"
                @onClick="sidebarResponsive = false"
                @closeSidemenu="closeSidebar"
            ></base-sidebar>
            <router-view @responsiveSideBar="sidebarResponsive ^= true" />
            <base-toast></base-toast>
        </div>
    </div>
</template>

<style lang="scss">
@import 'assets/scss/app.scss';
</style>
<style type="text/css">
:root {
    --primary-color: var(--primary-color);
    --secondary-color: var(--secondary-color);
    --interface-medium-color: var(--interface-medium-color);
    --interface-dark-color: var(--interface-dark-color);
}
</style>
<script>
export default {
    components: {},
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {}, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            sidebarResponsive: false,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Idel-State Handling > 
    |--------------------------------------------------------------------------
    */
    onIdle() {
        localStorage.removeItem('dataSegmentId')
        localStorage.removeItem('activeDataSegmentId')
        this.$store.commit('setDataSegmentId', null)
        this.$store.dispatch('authLogout')
    },
    onActive() {}, // End of Idel-State Handling
    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {}, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {
        this.getPublicIP();
    }, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        closeSidebar() {
            this.sidebarResponsive = false
        },
        async getPublicIP(){
            try{
                const {data} = await this.axios.get('https://api.ipify.org?format=json')
                this.$store.commit("setIp", data.ip);

            }catch(e) {
                console.log("error in getPublicIP", e);
            }
        }
    }, // End of Component > mounted
} // End of export default
</script>
